import chroma from 'chroma-js';
var validateShade = function validateShade(shade) {
  return chroma.valid(shade);
};
export default validateShade;